(() => {
 'use strict';
 document.addEventListener('change', event => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const section=select.closest('[data-product-section]'), option=select.selectedOptions[0];
  const price=section.querySelector('[data-product-price]');
  price.replaceChildren(document.createTextNode(option.dataset.price));
  if(option.dataset.compare){ const old=document.createElement('s'); old.textContent=option.dataset.compare;price.append(' ',old); }
  const available=option.dataset.available==='true';
  section.querySelector('[data-add-button]').disabled=!available;
  section.querySelector('[data-add-label]').textContent=available?'Add to cart':'Sold out';
  const url=new URL(window.location.href);url.searchParams.set('variant',option.value);window.history.replaceState({},'',url);
  const media=option.dataset.media && section.querySelector('[id$="-'+option.dataset.media+'"]');
  if(media) media.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'nearest'});
 });
 document.addEventListener('click',event=>{
  const menuLink=event.target.closest('.mobile-menu a');if(menuLink)menuLink.closest('details').open=false;
  const target=event.target;
  document.querySelectorAll('.desktop-nav details[open]').forEach(d=>{if(!d.contains(target))d.open=false;});
  const menu=document.querySelector('.mobile-menu[open]');if(menu&&!menu.contains(target))menu.open=false;
 });
 document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.mobile-menu[open],.desktop-nav details[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});}});
})();
